/* Kousek Severu - interakce nove homepage, hlavicky a FAQ. */
(function () {
  'use strict';

  /* ---------- mobilni menu ---------- */

  function initDrawer() {
    var drawer = document.querySelector('[data-ks-drawer]');
    if (!drawer || drawer.ksReady) return;
    drawer.ksReady = true;

    var openers = document.querySelectorAll('[data-ks-drawer-open]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      openers.forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
      var first = drawer.querySelector('[data-ks-drawer-close]');
      if (first) first.focus();
    }

    function close() {
      drawer.removeAttribute('open');
      document.body.style.overflow = '';
      openers.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openers.forEach(function (b) {
      b.addEventListener('click', open);
    });
    drawer.querySelectorAll('[data-ks-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.hasAttribute('open')) close();
    });
  }

  /* ---------- karusel (hero i recenze) ---------- */

  function initCarousels(root) {
    (root || document).querySelectorAll('[data-ks-carousel]').forEach(function (el) {
      if (el.ksReady) return;
      el.ksReady = true;

      var groups = el.querySelectorAll('[data-ks-slides]');
      var dots = el.querySelectorAll('[data-ks-dot]');
      var count = parseInt(el.getAttribute('data-ks-count'), 10) || dots.length;
      if (count < 1) return;
      var index = 0;
      var timer = null;
      var delay = parseInt(el.getAttribute('data-ks-autoplay'), 10) || 0;

      var progressThumb = el.querySelector('[data-ks-progress-thumb]');

      function show(i) {
        index = (i + count) % count;
        groups.forEach(function (group) {
          group.querySelectorAll('[data-ks-slide]').forEach(function (slide, n) {
            slide.classList.toggle('is-active', n === index);
          });
        });
        dots.forEach(function (dot, n) {
          dot.setAttribute('aria-current', n === index ? 'true' : 'false');
        });

        // Prouzek, ktery ukazuje, kolikaty snimek je videt.
        if (progressThumb && count > 1) {
          var sirka = 100 / count;
          progressThumb.style.width = sirka + '%';
          progressThumb.style.left = (index * (100 - sirka)) / (count - 1) + '%';
        }
      }

      function restart() {
        if (!delay) return;
        window.clearInterval(timer);
        timer = window.setInterval(function () {
          show(index + 1);
        }, delay);
      }

      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () {
          show(n);
          restart();
        });
      });

      var prev = el.querySelector('[data-ks-prev]');
      var next = el.querySelector('[data-ks-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          show(index - 1);
          restart();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          show(index + 1);
          restart();
        });
      }

      el.addEventListener('mouseenter', function () {
        window.clearInterval(timer);
      });
      el.addEventListener('mouseleave', restart);

      /* ---------- prejeti prstem ---------- */

      var startX = 0;
      var startY = 0;
      var smer = null; // 'vodorovne' | 'svisle'

      el.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length !== 1) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          smer = null;
          window.clearInterval(timer);
        },
        { passive: true }
      );

      el.addEventListener(
        'touchmove',
        function (e) {
          if (e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;

          // Smer rozhodneme jen jednou, aby tah neposkakoval mezi
          // listovanim a rolovanim stranky.
          if (smer === null && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
            smer = Math.abs(dx) > Math.abs(dy) ? 'vodorovne' : 'svisle';
          }

          // Pri vodorovnem tahu nesmi stranka rolovat do stran.
          if (smer === 'vodorovne' && e.cancelable) e.preventDefault();
        },
        { passive: false }
      );

      el.addEventListener(
        'touchend',
        function (e) {
          var konec = e.changedTouches && e.changedTouches[0];
          if (smer === 'vodorovne' && konec) {
            var dx = konec.clientX - startX;
            if (Math.abs(dx) > 40) show(dx < 0 ? index + 1 : index - 1);
          }
          smer = null;
          restart();
        },
        { passive: true }
      );

      el.addEventListener('touchcancel', function () {
        smer = null;
        restart();
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) delay = 0;

      show(0);
      restart();
    });
  }

  /* ---------- zalozky u produktu ---------- */

  function initTabs(root) {
    (root || document).querySelectorAll('[data-ks-tabs]').forEach(function (el) {
      if (el.ksReady) return;
      el.ksReady = true;

      var tabs = el.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (other) {
            var selected = other === tab;
            other.setAttribute('aria-selected', selected ? 'true' : 'false');
            other.setAttribute('tabindex', selected ? '0' : '-1');
            var panel = document.getElementById(other.getAttribute('aria-controls'));
            if (panel) panel.hidden = !selected;
          });
        });

        tab.addEventListener('keydown', function (e) {
          var list = Array.prototype.slice.call(tabs);
          var i = list.indexOf(tab);
          var target = null;
          if (e.key === 'ArrowRight') target = list[(i + 1) % list.length];
          if (e.key === 'ArrowLeft') target = list[(i - 1 + list.length) % list.length];
          if (target) {
            e.preventDefault();
            target.focus();
            target.click();
          }
        });
      });
    });
  }

  /* ---------- sloupce paticky: na mobilu sbalene ---------- */

  function initFooterColumns() {
    var cols = document.querySelectorAll('.ks-footer__col > summary');
    if (!cols.length) return;
    var mq = window.matchMedia('(max-width: 989px)');

    function apply() {
      cols.forEach(function (summary) {
        var details = summary.parentElement;
        if (details.ksUserToggled) return;
        if (mq.matches) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
        }
      });
    }

    cols.forEach(function (summary) {
      summary.addEventListener('click', function () {
        summary.parentElement.ksUserToggled = true;
      });
    });

    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  /* ---------- napoveda k posouvani ---------- */

  function initScrollHints(root) {
    (root || document).querySelectorAll('[data-ks-scroll-hint]').forEach(function (hint) {
      if (hint.ksReady) return;
      hint.ksReady = true;

      var scroller = hint.parentElement.querySelector('[data-ks-scroller]');
      if (!scroller) return;

      var label = hint.querySelector('[data-ks-hint-label]');
      var thumb = hint.querySelector('[data-ks-hint-thumb]');
      var DRAHA = 80; // 120 px kolejnice minus 40 px jezdce

      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth;

        // Kdyz se nema co posouvat, napoveda nema smysl.
        hint.classList.toggle('is-inactive', max <= 1);
        if (max <= 1) return;

        var podil = Math.min(1, Math.max(0, scroller.scrollLeft / max));
        if (thumb) thumb.style.left = Math.round(podil * DRAHA) + 'px';
        if (label) {
          if (podil > 0.03) {
            label.setAttribute('data-hidden', '');
          } else {
            label.removeAttribute('data-hidden');
          }
        }
      }

      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(root) {
    initDrawer();
    initCarousels(root);
    initTabs(root);
    initFooterColumns();
    initScrollHints(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
